import React, { useEffect, useState, useRef } from 'react';

// utils
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

// constant
import { channelList as channelListDefault } from '../../../constant/app/channel/index';
import { ManagementRoles } from '../../../constant/app/RolebasedAccess';

// API
import { templateMetrix, templateSyncApi } from '../api/Api';

// hooks
import useToggle from '../../../hooks/useToggle';

// redux
import { updateToggleToast } from '../../../reduxToolkit/appSlice';
import { useAspDispatch, useAspSelector } from '../../../test/jest-redux-hooks';

// components
// import SubSideBar from "../../../components/commonComponents/subSideBar";
// import WhatsappMainHeader from "../components/whatsapp/WhatsappMainHeader";
// import { ICONS } from "../../../assets/icons";

import { Divider, Flex, Menu, Typography } from 'antd';

const { SubMenu } = Menu;
const { Text, Title } = Typography;

// Define colors for styling
const defaultIconColor = '#8C8C8C'; // Gray
const selectedIconColor = '#00A85A'; // Dark Green
const selectedTextColor = '#00A85A'; // Dark Green
const selectedBgColor = '#E6F7EE'; // Light Green

const Channels = ({ isLoading }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { currentBrand, toggleToast, isAccountOwner, brandUserRoles, featureFlags } =
    useAspSelector((state) => state?.app);
  const dispatch = useAspDispatch();

  const [syncing, setSyncing] = useToggle(false);
  const [dataList, setDataList] = useState(null);
  const [openKeys, setOpenKeys] = useState([]);

  useEffect(() => {
    if (currentBrand?.brand_id) fetchTemplateMetrix(currentBrand?.brand_id);
  }, [currentBrand]);

  // Add effect to set openKeys based on current pathname
  useEffect(() => {
    const currentChannel = channelListDefault.find((channel) =>
      channel.subMenu?.some((subItem) => pathname.startsWith(subItem.link)),
    );
    if (currentChannel) {
      setOpenKeys([currentChannel.link || currentChannel.id]);
    }
  }, [pathname]);

  const fetchTemplateMetrix = async (brandId) => {
    try {
      const res = await templateMetrix(brandId);
      setDataList(res?.data);
    } catch (e) {
      console.warn(e);
    }
  };

  const brandId = currentBrand?.brand_id;

  const onClick = () => {
    if (brandId) {
      setSyncing(true);
      templateSyncApi(brandId)
        .then((res) => {
          if (res.status === 200) {
            dispatch(
              updateToggleToast([
                ...toggleToast,
                {
                  id: toggleToast?.length + 1,
                  content: 'Whatsapp Templates Synced Successfully',
                  status: 'Success',
                  duration: '',
                },
              ]),
            );
          } else {
            dispatch(
              updateToggleToast([
                ...toggleToast,
                {
                  id: toggleToast?.length + 1,
                  content:
                    res?.response?.data?.error ||
                    'Whatsapp Templates Sync failed',
                  status: 'Error',
                  duration: '',
                },
              ]),
            );
          }
        })
        .finally(() => {
          setSyncing(false);
        });
    } else {
    }
  };

  // const onClick = () => {};

  const handleMenuClick = (link) => {
    if (link) {
      navigate(link);
    }
  };

  // redirect to insights page by default if whatsapp is connected
  useEffect(() => {
    if (
      (currentBrand?.is_whatsapp_connected &&
        currentBrand?.brand_mode === 'live') ||
      (!currentBrand?.is_whatsapp_connected &&
        currentBrand?.brand_mode === 'test')
    ) {
      if (
        pathname.replace(/\/$/, '') === '/user/channels' ||
        pathname.replace(/\/$/, '') === '/user/channels/whatsapp'
      ) {
        navigate('/user/channels/whatsapp/insights');
      }
    }
  }, [pathname]);

  return (
    <Flex className="h-full">
      <Flex className="h-screen ">
        <Flex vertical className="bg-[#fff] ">
          <div className="px-4 pt-4">
            <Title level={4} style={{ marginBottom: '10px' }}>
              Channels
            </Title>
          </div>
          <Divider className="m-0 mb-10" />
          <div className="override-default-submenu-styles-channels-submenu">
            <Menu
              mode="inline"
              style={{ border: 'none' }}
              selectedKeys={[pathname]}
              openKeys={openKeys}
              onOpenChange={setOpenKeys}
              className="px-2 min-w-[13vw]"
            >
              {channelListDefault.map((channel) => {
                // Create a copy of the submenu to avoid mutating the original
                let filteredSubMenu = [...(channel.subMenu || [])];

                // Filter out Payment Configurations if the feature flag is disabled
                if (!featureFlags?.whatsapp_payment_feature ||
                  !currentBrand?.brand_billing_plan_name?.toLowerCase()?.endsWith('india')
                ) {
                  filteredSubMenu = filteredSubMenu.filter(
                    item => item.label !== 'Payment Configurations'
                  );
                }

                // Filter out Flows if the feature flag is disabled
                if (!featureFlags?.whatsapp_flow_feature) {                  
                  filteredSubMenu = filteredSubMenu.filter(
                    item => item.label !== 'Flows'
                  );
                }

                let showSubMenu = filteredSubMenu && filteredSubMenu.length > 0;

                switch (channel.label) {
                  case 'whatsapp':
                    showSubMenu =
                      showSubMenu &&
                      ((currentBrand?.is_whatsapp_connected === true &&
                        currentBrand?.brand_mode === 'live') ||
                        (currentBrand?.is_whatsapp_connected === false &&
                          currentBrand?.brand_mode === 'test'));
                    break;
                  case 'webchat':
                    let toShowSubmenu = false;
                    if (isAccountOwner) {
                      toShowSubmenu = true;
                    } else {
                      brandUserRoles.forEach((bur) => {
                        if (ManagementRoles.includes(bur.role)) {
                          toShowSubmenu = true;
                        }
                      });
                    }
                    showSubMenu = toShowSubmenu;
                    break;
                  default:
                    break;
                }

                if (channel.label === 'webchat' && !featureFlags.webchat_feature) return null;

                return showSubMenu ? (
                  <SubMenu
                    key={channel.link || channel.id}
                    className="min-w-[14vw] ps-0 bg-white"
                    title={
                      <Flex align="center" gap={8}>
                        {channel.mainLogo && (
                          <img
                            src={channel.mainLogo}
                            alt={channel.name}
                            style={{ width: 20, height: 20 }}
                          />
                        )}
                        <Text className="text-xs" strong>
                          {channel.name}
                        </Text>
                      </Flex>
                    }
                  >
                    {filteredSubMenu.map((subItem) => {
                      const IconComponent = subItem.icon;
                      // const isSelected = pathname === subItem.link;
                      const isSelected = pathname.startsWith(subItem.link);
                      const iconColor = isSelected
                        ? selectedIconColor
                        : defaultIconColor;
                      return (
                        <Menu.Item
                          key={subItem.link}
                          className="group hover:bg-gray-200"
                          onClick={() => handleMenuClick(subItem.link)}
                          style={{
                            backgroundColor: isSelected && selectedBgColor,
                            borderRadius: '6px',
                            margin: '4px 0',
                          }}
                        >
                          <Flex align="center" gap={8}>
                            {IconComponent && (
                              <IconComponent
                                style={{ width: 16, height: 16 }}
                                fill={'transparent'}
                                stroke={
                                  isSelected
                                    ? selectedIconColor
                                    : 'currentColor'
                                }
                                color={
                                  isSelected
                                    ? selectedIconColor
                                    : 'currentColor'
                                }
                                className="text-gray-500 group-hover:text-black"
                              />
                            )}
                            <Text
                              style={{
                                color: isSelected && selectedTextColor,
                              }}
                              className="text-gray-500 group-hover:text-black text-xs"
                            >
                              {subItem.name}
                            </Text>
                          </Flex>
                        </Menu.Item>
                      );
                    })}
                  </SubMenu>
                ) : (
                  <Menu.Item
                    key={channel.link || channel.id}
                    onClick={() => handleMenuClick(channel.link)}
                    disabled={!showSubMenu}
                    hidden
                  >
                    <Flex align="center" gap={8}>
                      {channel.mainLogo && (
                        <img
                          src={channel.mainLogo}
                          alt={channel.name}
                          style={{ width: 20, height: 20 }}
                        />
                      )}
                      {channel.LogoComponent && (
                        <div style={{ width: 20, height: 20 }}>
                          <channel.LogoComponent />
                        </div>
                      )}
                      <Text className="text-xs" strong>
                        {channel.name}
                      </Text>
                    </Flex>
                  </Menu.Item>
                );
              })}
            </Menu>
          </div>
        </Flex>
      </Flex>
      <Flex
        vertical
        className="h-screen p-6 w-full min-w-[800px] overflow-scroll"
      >
        <Outlet
          context={{
            syncing,
            setSyncing,
            isLoading,
            dataList,
            onClick,
          }}
        />
      </Flex>
    </Flex>
  );
};

export default Channels;
